"use client";
import { useCurrentAccountId } from "@zapier/identity";
import { useAtomValue } from "jotai";
import { Suspense, useEffect } from "react";
import FullStory, { FullStoryAPI } from "react-fullstory";
import { sessionAtom } from "@zapier/canvas-state";

declare global {
  interface Window {
    Intercom: (
      action: string,
      options?: number | Record<string, string | undefined>,
    ) => void;
  }
}

export default function ThirdPartyIntegrations() {
  const authState = useAtomValue(sessionAtom);
  const accountId = useCurrentAccountId();

  useEffect(() => {
    if (
      authState !== null &&
      (process.env.VERCEL_ENV !== "development" ||
        typeof window !== "undefined")
    ) {
      const { first_name, last_name, email } = authState;
      // Identify method
      const fullName = `${first_name} ${last_name}`;
      // @ts-ignore identify is sure as heck a correct value here
      FullStoryAPI("identify", authState.id, {
        email,
        fullName,
        accountId,
      });
    }
  }, [authState, accountId]);

  if (process.env.VERCEL_ENV === "development") {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <FullStory org="1XM" />
    </Suspense>
  );
}
